import { render, staticRenderFns } from "./GsAnnual.vue?vue&type=template&id=523ce2e0"
import script from "./GsAnnual.vue?vue&type=script&lang=js"
export * from "./GsAnnual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports